import { IACDLEvent } from '../../../../__legacy__/services/eventBus.service';

export const CurrentWorkspaceChangedEventType = Symbol('CURRENT_WORKSPACE_CHANGED_EVENT');

export class CurrentWorkspaceChangedEvent implements IACDLEvent {
  constructor(public willBeNavigatedToDifferentPath: boolean) {}

  readonly type: symbol = CurrentWorkspaceChangedEventType;
}
